import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mfooter',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class MfooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
